import { render, staticRenderFns } from "./DashboardLocation.vue?vue&type=template&id=5798ebb6&"
import script from "./DashboardLocation.vue?vue&type=script&lang=js&"
export * from "./DashboardLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports